import {
    type RefreshTokenResponseType
} from "./type";
import AsyncStorage from "@react-native-async-storage/async-storage";
import {
    SERVER_ADDRESS
} from "../../constants";

const RefreshToken = async (): Promise<RefreshTokenResponseType> => {
    const refreshToken = await AsyncStorage.getItem("authRefreshToken");
    const accessToken = await AsyncStorage.getItem("authToken");

    const response = await fetch(`${SERVER_ADDRESS}/auth/refreshToken`, {
        headers: {
            "Authorization": `Bearer ${accessToken}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            refreshToken: refreshToken,
            token: refreshToken
        }),
        method: "POST"
    });

    const data = await response.json() as RefreshTokenResponseType;

    if(!response.ok) {
        throw data;
    }

    if(data.payload?.accessToken) {
        await AsyncStorage.setItem("authToken", data.payload.accessToken);
        await AsyncStorage.setItem("authRefreshToken", data.payload.refreshToken);

        if (data.payload.userInfo) {
            const currentUser = await AsyncStorage.getItem("authUser");
            let parsedUser = currentUser ? JSON.parse(currentUser) : {};
            parsedUser = {
                ...parsedUser,
                ...data.payload.userInfo,
                role: data.payload.userInfo.type || data.payload.userInfo.adminType || parsedUser.role || "admin"
            };
            await AsyncStorage.setItem("authUser", JSON.stringify(parsedUser));

            // Assuming RESTServiceContext is accessible or AuthContext listens to this
            // We need to import RESTServiceContext if we want to emit
        }
    }

    return data;
};

export default RefreshToken;
